import apiClient from './axios';
import { normalizeSearchTerm } from './search';

export async function fetchDevices({ offset = 0, limit = 50, search = '' } = {}) {
  const normalizedSearch = normalizeSearchTerm(search);

  const res = await apiClient.get('/v3/device', {
    params: { 
      offset: offset, 
      limit: limit,
      search: normalizedSearch || undefined,
    },
  });

  // console.log(`fetchDevices -> ${ JSON.stringify( res, null, 2 )}`);

  return res;
}
